import React from 'react';
import {Button, Icon} from 'antd';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Box, ShowIf, Text } from '../../shared/components';
import Flex from '../../shared/components/basic/Flex';
import {
  processFinalSelection,
  setInicializado,
} from '../../../state/actions/creators/pel.actioncreator';

function PELFooter({
  history, processFinalSelection, setInicializado, sagas, lentes, montura, onGoBack, onSeleccionarLente, onClose, showTopBorder, pedirSuplementos, viene_de
}) {
  const goBackHandler = () => {
    setInicializado(true);
    if (onGoBack) {
      onGoBack();
    } else {
      history.goBack();
    }
  };
  let tieneLenteSeleccionada = false;
  let lenteSeleccionada;
  const lentesKeys = Object.keys(lentes);

  for (let i = 0; i < lentesKeys.length; i += 1) {
    if (lentes[lentesKeys[i]].isSelected) {
      tieneLenteSeleccionada = true;
      lenteSeleccionada = lentes[lentesKeys[i]];
      break;
    }
  }
  const loadingDiametrosYColores = sagas?.LENTES_PEL_GET_DIAMETROS_POSIBLES?.running || sagas?.LENTES_PEL_GET_COLORES_LENTE?.running;
  const tieneSuplObligatorio = lenteSeleccionada ? lenteSeleccionada.tieneSuplObligatorio : false;
  const tieneRestriccionPrecio = lenteSeleccionada ? lenteSeleccionada.tratamientos.find(e => e.isSelected).tieneRestriccionPrecio : false;
  return (
    <Flex p={16} justifyContent="space-between" alignItems="baseline" borderTop={showTopBorder ? '1px solid #f0f0f0' : '0px'}>
      <Box>
        <style>{'.ant-btn .anticon{ line-height:0 }'}</style>
        <Button icon="left" onClick={() => goBackHandler()}>
          <Text>Atrás</Text>
        </Button>
      </Box>
      <Flex>
        <Box mr={12}>
          <Button onClick={() => onClose()}>
            <Text>Cancelar</Text>
          </Button>
        </Box>
        <Flex>
          <ShowIf condition={(tieneSuplObligatorio || (montura && montura.tieneFormaOma)) && viene_de != 'presupuesto' }>
            <Button disabled={!tieneLenteSeleccionada || tieneRestriccionPrecio || loadingDiametrosYColores} type="primary" onClick={() => processFinalSelection(true, pedirSuplementos, onSeleccionarLente)}><Text>Configurar Suplementos</Text></Button>
          </ShowIf>
          <ShowIf condition={!(tieneSuplObligatorio || (montura && montura.tieneFormaOma)) || viene_de == 'presupuesto' }>
            <Box mr={12}><Button disabled={!tieneLenteSeleccionada || tieneRestriccionPrecio || loadingDiametrosYColores} onClick={() => processFinalSelection(true, pedirSuplementos, onSeleccionarLente)}><Text>Añadir Suplementos</Text></Button></Box>
            <Button disabled={!tieneLenteSeleccionada || tieneRestriccionPrecio || loadingDiametrosYColores} type="primary" onClick={() => processFinalSelection(false, pedirSuplementos, onSeleccionarLente)}><Text>Seleccionar Lentes</Text></Button>
          </ShowIf>
        </Flex>
      </Flex>
    </Flex>
  );
}
const mapStateToProps = ({ pel, sagas }) => ({
  modo: pel.modo,
  lentes: pel.filtrador.lentes,
  montura: pel.filtrador.selecciones.montura,
  sagas: sagas,

});
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    processFinalSelection,
    setInicializado,
  }, dispatch);
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PELFooter);

PELFooter.propTypes = {
  history: PropTypes.shape({ goBack: PropTypes.func }),
  setInicializado: PropTypes.func,
  onGoBack: PropTypes.func,
  processFinalSelection: PropTypes.func,
  onSeleccionarLente: PropTypes.func,
  onClose: PropTypes.func,
  showTopBorder: PropTypes.bool,
  pedirSuplementos: PropTypes.bool,
};

PELFooter.defaultProps = {
  processFinalSelection: () => {},
  setInicializado: () => {},
  onSeleccionarLente: () => {},
  onClose: () => {},
  history: undefined,
  onGoBack: null,
  showTopBorder: false,
  pedirSuplementos: false,
};
